import { useTranslation } from "react-i18next";
import { equalsIgnoreCase } from "../../../../_utils";
import { ModalApp } from "../ModalApp";
import styleModal from "./ModalKYC.module.scss";
import { KycFinishStatus } from "../../../../services/parrentApp.service";
import { ROUTES } from "../../../../hooks";
import { useNavigate } from 'react-router-dom';
import { ReactComponent as WARN } from "../../../../assets/images/icon_cansel.svg";
import { ReactComponent as OK } from "../../../../assets/images/icon_on.svg";

export const KYCModal = ({ kycModal, setKycModal }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isSuccess = equalsIgnoreCase(kycModal, KycFinishStatus.COMPLETED);

  const onHide = () => setKycModal(null);

  const getTranslationKeyFromKycStatus = (kycStatus: KycFinishStatus | null) => {
    switch(kycStatus) {
      case KycFinishStatus.CANCELED:
        return 'kyc.verification_canceled_message';
      case KycFinishStatus.FAILED:
        return 'kyc.verification_failed_message';
      case KycFinishStatus.COMPLETED:
        return 'kyc.verification_completed_message';
      case null:
        return "";
      default:
        throw new Error(`Unexpected KYC status: ${kycStatus}`);
    }
  }

  return (
    <ModalApp 
      show={!!kycModal} 
      onHide={onHide}
      customHeader={styleModal.KYC_modal_header}
      titleIcon={ isSuccess ? <OK /> : <WARN /> }
      title={ isSuccess ? t("kyc.verification_successful") : t("kyc.verification_unsuccessful") }
    >
      <div className={styleModal.KYC_modal_cont}>
        <p>{ t(getTranslationKeyFromKycStatus(kycModal)) }</p>
        { !isSuccess &&
          <ul>
            <span>{ t("kyc.tips_verification") }</span>
            <li>{ t("kyc.valid_id") }</li>
            <li>{ t("kyc.id_visible") }</li>
            <li>{ t("kyc.process_private") }</li>
          </ul>
        }
        <div className={styleModal.button_cont}>
          <button className="transparent_btn_big" onClick={onHide}>
            { t('comman_word.dismiss_txt') }
          </button>
          <button className="main_btn" onClick={() => {
              navigate(ROUTES.account);
              onHide();
            }}
          >
            { isSuccess ? t("kyc.make_deposit") : t("comman_word.try_again") }
          </button>
        </div>
      </div>
    </ModalApp>
  );
}
